import React from 'react';
import { Row } from 'react-bootstrap';
import { StyledRadioInput } from '../../../Helpers/Inputs';
import PropTypes from 'prop-types';

import './TobaccoRadio.scss';

export default function TobaccoRadio(props) {

  return (
    <Row className="pe-3 tobacco-radio">
      <StyledRadioInput
        name="tobacco"
        id="tobacco"
        label={props.verbiage.label}
        value={props.tobacco}
        options={[{ value: "true", label: props.verbiage.yes }, { value: "false", label: props.verbiage.no }]}
        onChange={(e) => props.onChange(e)}
      />
    </Row>
  );
}

TobaccoRadio.propTypes = {
  verbiage: PropTypes.shape({
    label: PropTypes.string.isRequired,
    yes: PropTypes.string.isRequired,
    no: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  tobacco: PropTypes.string,
};
